import {
  Box,
  Container,
  Checkbox,
  Divider,
  Grid,
  styled,
  Typography,
} from "@mui/material";
import axios from "axios";
import {
  AutoCompleteComponent,
  CheckboxInput,
  CurrencyDisplay,
  CurrencyNumberInput,
  DatePicker,
  DateRangePicker,
  FormLabel,
  ModalError,
  Page,
  PrimaryButton,
  SectionLabel,
  SkeletonComponent,
  SwitchInput,
  TextInput,
} from "components";
import { InnoTableV2 } from "inno-ui";
import { HeaderTitle } from "layouts";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router";
import { globalStyles } from "styles";
import { hardBaseUrl } from "../../../../../services/urlConstant";

const mockDataClaim = [
  {
    dsp: "Spotify",
    period: "20 Jan 2025 - 20 Feb 2025",
    traffic: "1000",
    revenue: "1000000",
    status: "Final",
    type: "DSP",
  },
  {
    dsp: "Apple Music",
    period: "20 Des 2024 - 20 Jan 2025",
    traffic: "1000",
    revenue: "265000000",
    status: "Final",
    type: "DSP",
  },
];

function PaymentComposerInvoice({
  pageTitle,
  pageSubTitle,
  loadingPage,
  preload,
  editMode,
}) {
  const params = useParams();
  const classes = globalStyles();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const isEditing = params?.id;
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [payload, setPayload] = useState({
    transaction_name: "claim",
    type: "usage",
    claim_type: "claim",
    invoice_number: "",
    transaction_number: "",
    po_number: "",
    invoice_date: moment(),
    dsp_id: 0,
    end_date: moment(),
    start_date: moment(),
    exchange_rate: 0,
    job_number: "",
    account_number: 0,
    is_all_song: false,
    songs: [],
    revenue: 0,
    note: "",
    taxes: [],
  });
  const [optionClient, setOptionClient] = useState([]);

  const isUsageInvoice = payload?.type === "usage";
  const payloadDspId = payload?.dsp_id;
  let selectedDSP = optionClient?.find(dsp => dsp.dsp_id === payloadDspId);
  const [dataTable, setDataTable] = useState([]);

  const initialPayload = useRef(payload);
  const hasPayloadChanges =
    JSON.stringify(initialPayload?.current) !== JSON.stringify(payload);
  const hasChanges = !editMode ? hasPayloadChanges : false;
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const allListInvoicesSelected = dataTable?.every(option =>
    selectedInvoices?.some(
      selected => selected?.composer_id === option?.composer_id
    )
  );
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
    search: "",
  });

  const handleSelectInvoices = (event, option) => {
    const { checked } = event?.target || false;
    setSelectedInvoices(prev =>
      checked
        ? [...prev, option]
        : prev.filter(item => item.composer_id !== option.composer_id)
    );
  };
  const handleSelectAllInvoices = event => {
    const { checked } = event?.target || false;
    setSelectedInvoices(checked ? dataTable : []);
  };

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };

  const setPreload = () => {
    if (preload && preload.period) {
      const [startPeriod, endPeriod] = preload?.period?.split(" - ");
      let start_date, end_date;

      start_date = formatPreloadDate(startPeriod);
      end_date = formatPreloadDate(endPeriod);

      const modifiedPreload = {
        ...preload,
        start_date,
        end_date,
        invoice_number: preload?.transaction_number,
        invoice_date: formatPreloadDate(preload?.invoice_date),
      };
      setPayload(modifiedPreload);
    }
  };

  const getClientList = async () => {
    const url = `${hardBaseUrl}/master/all-client`;
    try {
      const res = await axios.get(url, { headers });
      const { data } = res?.data;
      const modifiedData = [
        {
          id: 0,
          label: "None",
        },
        ...data?.map(item => ({
          ...item,
          id: item?.dsp_id,
          label: item?.dsp_name,
        })),
      ];
      setOptionClient(modifiedData);
    } catch (error) {
      ModalError(error);
    }
  };
  const getExchangeRate = async () => {
    const currentDate = moment().format("DD MMM YYYY");
    const dspCurrencyId = selectedDSP?.dsp_currency?.id;
    const countryCurrencyId = selectedDSP?.country?.currency?.id;
    const currencyId = dspCurrencyId || countryCurrencyId;
    const url = `${hardBaseUrl}/exchange-rate/code?currency_id=${currencyId}&upload_date=${currentDate}`;
    if (currencyId) {
      try {
        const res = await axios.get(url, { headers });
        const resValue = res?.data?.data?.value;
        handleChangePayload(Number(resValue), "exchange_rate");
      } catch (error) {
        ModalError(error);
      }
    }
  };
  const getBaseCurrency = async () => {
    const { dsp_id, start_date, end_date } = payload;
    try {
      const res = await axios.get(
        `${hardBaseUrl}/publisher/transaction-claim/total-dsp-revenue`,
        {
          headers,
          params: {
            dsp_id,
            start_date: start_date.format("YYYY-MM"),
            end_date: end_date.format("YYYY-MM"),
          },
        }
      );
      const { data } = res?.data;
      handleChangePayload(Number(data?.original_currency_revenue), "revenue");
    } catch (error) {
      ModalError(error);
    }
  };

  useEffect(() => {
    getClientList();
  }, []);
  useEffect(() => {
    setPreload();
  }, [preload]);
  useEffect(() => {
    getExchangeRate();
  }, [payloadDspId]);
  useEffect(() => {
    if (payloadDspId) {
      getBaseCurrency();
    }
  }, [payloadDspId, payload?.start_date, payload?.end_date]);
  useEffect(() => {
    const handleBeforeUnload = event => {
      if (hasChanges) {
        event.preventDefault();
        event.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasChanges]);
  useEffect(() => {
    const unblock = history.block(() => {
      if (hasChanges) {
        return "You have unsaved changes. Are you sure you want to leave this page?";
      }
    });

    return () => {
      unblock();
    };
  }, [history, hasChanges]);

  const columnTableListInvoicesDetail = [
    {
      name: "all",
      title: (
        <Box>
          <CustomCheckbox
            checked={allListInvoicesSelected}
            onChange={handleSelectAllInvoices}
          />
          Action
        </Box>
      ),
      renderText: item => (
        <Box>
          <CustomCheckbox
            checked={selectedInvoices?.some(
              selected => selected?.composer_id === item?.composer_id
            )}
            onChange={e => handleSelectInvoices(e, item)}
          />
        </Box>
      ),
    },
    {
      name: "dsp",
      title: "Invoice Date",
    },
    {
      name: "period",
      title: "Invoice Number",
    },
    {
      name: "traffic",
      title: "Composer",
    },
    {
      name: "revenue",
      title: "Invoice Value",
      renderText: revenue => (
        <CurrencyDisplay
          value={revenue}
          decimalScale={2}
          suffix=",-"
          prefix="Rp "
        />
      ),
      textAlign: "right",
    },
    {
      name: "status",
      title: "Generated By",
    },
    {
      name: "status",
      title: "Status",
    },
  ];

  return (
    <Page className={classes?.root} title={pageTitle}>
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle
            title={`${isEditing ? "Edit" : "Create"} Payment Composer Invoice`}
            breadcrumbData={breadcrumbData(pageTitle)}
            backButton
          />
          <Divider className={classes?.divider} />
          <SectionLabel subTitle={pageSubTitle} />
          <Box border="1px solid #ebebeb" borderRadius="6px" p="24px" mt="16px">
            <Grid container columnSpacing={2} rowSpacing={1} spacing={2}>
              <Grid item xs={12} md={6}>
                <FormLabel label="Payment No" />
                <TextInput
                  disabled={editMode}
                  placeholder="Payment No"
                  value={payload?.invoice_number}
                  onChange={event =>
                    handleChangePayload(event?.target?.value, "payment_no")
                  }
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel label="Date" />
                <DatePicker
                  value={payload?.payment_date}
                  onChange={date => handleChangePayload(date, "payment_date")}
                  minDate={preload ? null : moment()}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <FormLabel label="Composer" required />
                <AutoCompleteComponent
                  options={optionClient}
                  value={
                    optionClient.find(option => option.id === payloadDspId) ||
                    null
                  }
                  onChange={value => handleChangePayload(value, "dsp_id")}
                  size="small"
                  width="100%"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel label="Notes" />
                <TextInput
                  placeholder="Notes"
                  value={payload?.note}
                  onChange={event =>
                    handleChangePayload(event?.target?.value, "note")
                  }
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} my={1}>
                <SectionLabel title="List Invoices" mb="16px" />
                <InnoTableV2
                  columns={columnTableListInvoicesDetail}
                  items={isUsageInvoice ? payload?.songs : mockDataClaim || []}
                  isLoading={false}
                  page={queryParams?.page}
                  rowsPerPage={queryParams?.size}
                  totalPage={tableTotalPage}
                />
              </Grid>
              <Grid item xs={12}>
                <Box>
                  <Box bgcolor="#fafafa" borderRadius="6px" p="14px" mt="24px">
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid item>
                        <Typography fontWeight="bold" fontSize="24px">
                          Total Value
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography fontWeight="bold" fontSize="24px">
                          <CurrencyDisplay
                            value={0.0}
                            prefix={"Rp"}
                            decimalScale={2}
                            suffix=",-"
                          />
                        </Typography>
                      </Grid>
                    </Grid>
                    <Divider className={classes?.divider} />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box justifyContent="flex-end" display="flex">
                  <Grid container justifyContent="flex-end" spacing={1}>
                    <Grid item>
                      <PrimaryButton
                        label="Save As Draft"
                        onClick={() => console.log("Save As Draft")}
                        disabled={loadingPage}
                        loading={loadingPage}
                      />
                    </Grid>
                    <Grid item>
                      <PrimaryButton
                        label="Send To Approval"
                        onClick={() => console.log("Save To Approval")}
                        disabled={loadingPage}
                        loading={loadingPage}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      )}
    </Page>
  );
}
const formatPreloadDate = date => moment(date, "DD MMMM YYYY");

const breadcrumbData = pageTitle => [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Transaction",
    link: "/admin/sales-invoice",
  },
  {
    label: pageTitle,
    active: true,
  },
];

const CustomCheckbox = styled(Checkbox)(({ customColor }) => ({
  "&.MuiCheckbox-root": {
    color: customColor || "#111827",
    "&.Mui-checked": {
      color: customColor || "#111827",
    },
  },
}));

export default PaymentComposerInvoice;
